export default {
  isUserAllowed() {
    return {
      data: {
        status: 'Approved',
        'prescreened-amount': 15000,
      },
    };
  },
};
